import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';

import api from '../../services/api';

import getFormatedDateTime from '../../utils/getFormatedDateTime';

interface File {
  id: string;
  path: string;
  final: boolean;
}

interface Log {
  id: string;
  datetime: string;
  observacoes: string;
  status: string;
  usuario_responsavel: string;
}

export interface Budget {
  id: number;
  type: string;
  datetime: string;
  company: string;
  cnpj: string;
  observations: string;
  price: number;
  status: string;
  status_id: number;
  files?: Array<File>;
  logs?: Array<Log>;
}

const Budget: React.FC = () => {
  const location = useLocation();

  const [budgets, setBudgets] = useState<Budget[]>();

  useEffect(() => {
    api.get('user-budgets-list').then(response => {
      setBudgets(response.data);
    });
  }, [location.pathname]);

  return (
    <>
      <h5 className="spacer">ORÇAMENTOS</h5>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
        molestie elit vitae varius maximus.
      </p>

      <div className="spacer" />

      {budgets && budgets.length ? (
        <div className="table-responsive">
          <table className="table" width="100%">
            <thead>
              <tr>
                <th>Nº</th>
                <th>DATA/HORA</th>
                <th>EMPRESA</th>
                <th>CNPJ</th>
                <th>SITUAÇÃO</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {budgets.map(ad => (
                <tr key={ad.id}>
                  <td>{ad.id}</td>
                  <td>{getFormatedDateTime(ad.datetime)}</td>
                  <td>{ad.company}</td>
                  <td>{ad.cnpj}</td>
                  <td>{ad.status}</td>
                  <td className="text-right">
                    <Link to={`/budgets/${ad.id}`}>
                      <FiSearch size={18} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          {budgets && budgets.length === 0 ? (
            <div>Nenhum resultado encontrado.</div>
          ) : (
            <div>Pesquisando, aguarde...</div>
          )}
        </div>
      )}

      <div className="row">
        <div className="col d-flex align-items-center" />
        <div className="col text-right">
          <Link to="/budgets/register" className="btn btn-primary btn-sm">
            Novo orçamento
          </Link>
        </div>
      </div>
    </>
  );
};

export default Budget;
